import React, { useContext, useState } from 'react';
import { arrayOf, string, func } from 'prop-types';
import { DropDownItem } from '@thd-olt-component-react/core-ui';
import { DropDownSearch } from '../../genericcomponents/DropDownSearch/DropDownSearch';
import styles from './car-picker-dropdown-with-search-mobile.module.scss';
import { I_DONT_KNOW } from '../../../constants';

const CarPickerDropDownWithSearchMobile = ({ items, onChoose, selectOption }) => {
  const [searchField, setSearchField] = useState('');
  const itemFilter = (item) => (item.toLowerCase().includes(searchField.toLowerCase()) || item === I_DONT_KNOW);
  return (
    <div className={`drop-down__content-wrapper ${styles['content-wrapper']}`}>

      <DropDownSearch onChange={(query) => setSearchField(query)} border={false} />

      <div className={styles['content-area']}>
        {selectOption && <DropDownItem>{selectOption}</DropDownItem>}
        {items.filter(itemFilter).map((value) => {
          return <DropDownItem key={value} onClick={() => onChoose(value)}>{value}</DropDownItem>;
        })}
      </div>
    </div>
  );
};

CarPickerDropDownWithSearchMobile.propTypes = {
  items: arrayOf(string),
  onChoose: func,
  selectOption: string
};

CarPickerDropDownWithSearchMobile.defaultProps = {
  items: [],
  onChoose: () => { },
  selectOption: null
};

export { CarPickerDropDownWithSearchMobile };